function initProductGallery() {

  const productSections =
    document.querySelectorAll(
      "[data-product-section]"
    );


  productSections.forEach(
    (section) => {

      const mainImage =
        section.querySelector(
          "[data-product-main-image]"
        );


      const thumbnails =
        Array.from(
          section.querySelectorAll(
            "[data-product-thumbnail]"
          )
        );


      if (
        !mainImage ||
        thumbnails.length === 0
      ) {
        return;
      }


      if (
        section.dataset.galleryInitialized ===
        "true"
      ) {
        return;
      }


      section.dataset.galleryInitialized =
        "true";


      function setActiveThumbnail(
        selectedThumbnail
      ) {

        thumbnails.forEach(
          (thumbnail) => {

            const active =
              thumbnail ===
              selectedThumbnail;


            thumbnail.classList.toggle(
              "active",
              active
            );


            thumbnail.setAttribute(
              "aria-pressed",
              active
                ? "true"
                : "false"
            );

          }
        );

      }


      function changeImage(
        thumbnail
      ) {

        const newSource =
          thumbnail.dataset.imageSrc;


        const newAlt =
          thumbnail.dataset.imageAlt || "";


        if (!newSource) {
          return;
        }


        const resolvedSource =
          new URL(
            newSource,
            window.location.origin
          ).href;


        if (
          mainImage.src ===
          resolvedSource
        ) {

          setActiveThumbnail(
            thumbnail
          );

          return;

        }


        setActiveThumbnail(
          thumbnail
        );


        mainImage.classList.add(
          "is-changing"
        );


        const preloadImage =
          new Image();


        preloadImage.src =
          newSource;


        preloadImage.onload =
          () => {

            window.setTimeout(
              () => {

                mainImage.src =
                  newSource;


                mainImage.alt =
                  newAlt;


                requestAnimationFrame(
                  () => {

                    mainImage.classList.remove(
                      "is-changing"
                    );

                  }
                );

              },
              120
            );

          };


        preloadImage.onerror =
          () => {

            mainImage.classList.remove(
              "is-changing"
            );

          };

      }


      function showImageById(
        imageId
      ) {

        if (!imageId) {
          return;
        }


        const thumbnail =
          thumbnails.find(
            (item) =>
              item.dataset.imageId ===
              String(imageId)
          );


        if (!thumbnail) {
          return;
        }


        changeImage(
          thumbnail
        );

      }


      thumbnails.forEach(
        (thumbnail) => {

          thumbnail.addEventListener(
            "click",
            () => {

              changeImage(
                thumbnail
              );

            }
          );

        }
      );


      /*
        Variant handling can tell the
        gallery to display a specific
        Shopify image.
      */

      section.addEventListener(
        "product:image-change",
        (event) => {

          showImageById(
            event.detail?.imageId
          );

        }
      );

    }
  );

}


document.addEventListener(
  "DOMContentLoaded",
  initProductGallery
);


document.addEventListener(
  "shopify:section:load",
  initProductGallery
);


initProductGallery();